import { v4 as uuidv4 } from 'uuid';
import GoTrue from 'gotrue-js';

function Auth(){
    this.login = function(firstName, lastName){
        const id = uuidv4();
        localStorage.setItem('user', JSON.stringify({
            id,
            firstName,
            lastName
        }));
        return {
            id,
            firstName,
            lastName
        };
    }
    this.currentUser = function(){
        if(!localStorage.getItem('user')){
            return null;
        }
        return {
            ...JSON.parse(localStorage.getItem('user')),
            update: data => {
                localStorage.setItem('user', JSON.stringify({
                    ...JSON.parse(localStorage.getItem('user')),
                    ...data
                }));
            }
        }
    }
    this.logout = function(){
        localStorage.removeItem('user');
    }
}

export function isOnline(p){
    return [ 'Decline', 'Error', 'Kicked', 'Left' ].indexOf(p.status) < 0;
}

export const auth = new Auth();

export async function request(url, method = 'GET', data){
    const { id } = await auth.currentUser();
    return fetch(url, {
        method,
        body: data && JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'X-User-Id': `${id}`
        }
    })
}

export async function upload(file, folder){
    const { signature, timestamp, apikey } = await (await request(`/api/common/signed`, 'POST', { folder })).json();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('signature', signature);
    formData.append('timestamp', timestamp);
    formData.append("api_key", apikey);
    formData.append("folder", folder);
    return await (await fetch(`https://api.cloudinary.com/v1_1/arjunganesan/auto/upload`, {
        method: 'POST',
        body: formData
    })).json();
}